import {
  AEMErrorMessage,
  AEMFeatureFlags,
  ComponentType
} from '@com-delta-idp/mnx-skymiles-shared';
import { AEMMedallionBannerContent } from './aem/medallion-banner.interfaces';
import { AEMMenuContent } from './aem/menu.interfaces';
import { Features } from './features.interfaces';

export interface LandingPageErrorEntity {
  aemMedallionBannerError?: string;
  aemMenuError?: string;
  aemFeatureFlagsError?: ComponentType;
  aemErrorMessagesError?: ComponentType;
  businessTravelerError?: boolean;
  aemBusinessTravelerFeatureFlagError?: boolean;
}

export interface LandingPageEntity extends LandingPageErrorEntity {
  id: string | number; // Primary ID
  aemMedallionBanner?: AEMMedallionBannerContent;
  aemMenu?: AEMMenuContent;
  aemFeatureFlags?: AEMFeatureFlags<Features>;
  aemErrorMessages?: AEMErrorMessage[];
  businessTraveler?: boolean;
  aemBusinessTravelerFeatureFlag?: boolean;
}
